module.exports = __webpack_public_path__ + "static/media/icon-6.0415c281.svg";